module.exports = __webpack_public_path__ + "img/dcu30-4.eb1d004e.png";